define.alias("shared/modifiers/show-on-hover", "settings/modifiers/show-on-hover");